import { InheritColors } from '@griply/types';
import { predefinedColorOptions } from '@griply/utils';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/components/ui/custom-form-select';

import * as Styled from './color-picker.style';

export type Options = {
  // The picker no longer offers the inherit values; it only keeps showing the one already stored.
  color?: string;
  parentColor?: string;
  lifeAreaColor?: string;
};

type ColorOption = {
  label: string;
  start: React.ReactNode;
  value: string;
  hasBottomSeparator?: boolean;
};

export const useColorOptions = ({
  color,
  parentColor,
  lifeAreaColor,
}: Options = {}) => {
  const { t } = useTranslation();

  return useMemo<Option[]>(() => {
    const options: ColorOption[] = [];

    if (color === InheritColors.LifeArea) {
      options.push({
        label: t('general.labels.colors.inherit.life-area'),
        value: InheritColors.LifeArea,
        start: <Styled.ColorCircle $color={lifeAreaColor ?? ''} />,
        hasBottomSeparator: true,
      });
    }

    if (color === InheritColors.Goal) {
      options.push({
        label: t('general.labels.colors.inherit.goal'),
        value: InheritColors.Goal,
        start: <Styled.ColorCircle $color={parentColor ?? ''} />,
        hasBottomSeparator: true,
      });
    }

    predefinedColorOptions.forEach((colorOption) =>
      options.push({
        ...colorOption,
        label: t(`general.colors.${colorOption.label}`),
        start: <Styled.ColorCircle $color={colorOption.value} />,
      }),
    );

    return options;
  }, [color, lifeAreaColor, parentColor, t]);
};
